/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetQuickLinksRequest, TGetQuickLinksModel, IMappers, TGetQuickLinksResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetQuickLinksV1ResponseSchema } from '../../entities/get_seo_links_newbuildings_v1/GetQuickLinksV1ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetQuickLinksModel(parameters: IGetQuickLinksRequest): TGetQuickLinksModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'seo-crosslinks',
    pathApi: '/v1/get-quick-links/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetQuickLinksOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetQuickLinksRequest;
}

export async function fetchGetQuickLinks<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetQuickLinksOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetQuickLinksResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetQuickLinksModel(parameters),
    config,
  )) as FetchResponse<TGetQuickLinksResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuickLinksV1ResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetQuickLinksResponse>;
}
